import React from 'react';
import { Modal, Input } from 'antd';
import LoadableButton from '../../buttons/LoadableButton';
const { TextArea } = Input;

export default function ConfirmationModal({ isOpen = false, setIsOpen, width, type, message, onConfirm, isLoading, loadingLabel = 'Loading...', textArea, placeholder, textAreaValue, setTextAreaValue, textAreaRows, extraContent }) {

    return (
        <Modal
            open={isOpen}
            closeIcon={false}
            footer={false}
            maskClosable={false}
            keyboard={false}
            width={width || 420}
        >
            <div className='lg:pb-1'>
                <div className='p-5'>
                    <div className="flex justify-center mt-2">
                        {type == 'success' ? (<img src="/assets/icons/Accept-icon.svg" alt="icon" width={64} />) : (<img src="/assets/icons/Reject-icon.svg" alt="icon" width={64} />)}
                    </div>
                    <p className={`text-lg text-[#2F2B3D] font-semibold text-center ${textArea || extraContent ? 'mt-5 mb-3' : 'my-6'}`}>{message}</p>
                    {textArea &&
                        <div>
                            <TextArea
                                className={` my-3`}
                                placeholder={placeholder}
                                value={textAreaValue}
                                onChange={(e) => setTextAreaValue(e.target.value)}
                                autoSize={{ minRows: textAreaRows ?? 3, maxRows: textAreaRows ?? 5 }}
                            />
                        </div>
                    }
                    {extraContent && <div className="mb-1">{extraContent}</div>}
                    <div className='flex justify-center items-center gap-4 mt-5'>
                        <button onClick={() => setIsOpen(false)} disabled={isLoading} className='bg-[#D91819] text-sm text-white font-medium uppercase px-10 py-2 rounded-lg hover:bg-[#aa0001] duration-500'>No</button>
                        <LoadableButton
                            className='bg-[#2D9B63] text-sm text-white font-medium uppercase px-10 py-2 rounded-lg hover:bg-[#096034] duration-500'
                            onClick={() => onConfirm()}
                            disabled={isLoading}
                            lable='Yes'
                            isLoading={isLoading}
                            loadingLable={loadingLabel}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    )
}
